import { render } from "./CounterParties.vue?vue&type=template&id=6183bd27&ts=true"
import script from "./CounterParties.vue?vue&type=script&lang=ts"
export * from "./CounterParties.vue?vue&type=script&lang=ts"

import "./CounterParties.vue?vue&type=style&index=0&id=6183bd27&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__